<template>
   <div class="imgupload">
      <el-form :inline="true" class="demo-form-inline" size="mini" ref="sendDataInfo" :show-message="false">
         <el-form-item>
            <el-upload class="upload-demo" :action="requesUrl + uploadUrl" :headers="header" :on-preview="handlePreview" :on-error="uploadFalse" multiple :limit="1" :on-progress="onprogress" :on-success="uploadSuccess"
                       :file-list="fileList">
               <el-button size="small" type="primary">上传excel文件</el-button>
            </el-upload>
         </el-form-item>
         <el-form-item>
            <el-button size="small" type="primary" :disabled="disabled" @click="onSubmit">提交</el-button>
         </el-form-item>
      </el-form>
      <el-form :inline="true" size="mini">
         <!-- 明细信息 -->
         <u-table class="baseTable" ref="mxTableRef" :row-height="20" :show-summary="true" :summary-method="getSummaries" :data="returnData.list" :row-style="rowStyle" ow-key="index" use-virtual :big-data-checkbox="true"
                  highlight-current-row size="mini" height="400">
            <u-table-column :sortable="formOneValue.isSort == 1 ? true : false" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in tableList" :key="formOneKey"
                            :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
            </u-table-column>
         </u-table>
      </el-form>
   </div>
</template>
<script>
export default {
   name: 'importListAction',
   data() {
      return {
         mxHeight: 500,
         fileList: [],
         returnData: { list: [] },
         requesUrl: this.$store.getters.getConfig.requestUrl,
         disabled: true,

      };
   },
   props: {
      uploadUrl: {
         type: String,
         default: () => {
            return ''
         }
      },
      tableList: {
         type: Array,
         default: () => {
            return []
         }
      },
      header: {
         type: Object,
         default: () => {
            return {
               // 'Content-Type': 'multipart/form-data',
               token: sessionStorage.getItem('token')
            }
         },
      },
      submitUrl: {
         type: String,
         default: () => {
            return ''
         }
      }
   },
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
   },
   methods: {
      onprogress(event, file, fileList) {
         this.disabled = true
         console.log(event, file, fileList);
      },
      uploadSuccess(response, file, fileList) {
         this.disabled = true
         this.fileList = []
         if (response.status == 200) {
            this.disabled = false
            this.returnData.list = response.result
         }
         console.log(response, file, fileList);
      },
      uploadFalse(response, file, fileList) {
         this.fileList = []
         alert("文件上传失败！");
      },
      // 触发组件的提交
      submitUpload() {
         this.$refs.upload.submit();
      },
      handlePreview(file) {
         console.log(file);
         this.fileList = []
         if (file.status) {
            alert("此文件导入成功");
         } else {
            alert("此文件导入失败");
         }
      },
      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", {
            // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
         });
         let rowBackground = {};
         if (row.bgColor && row.bgColor != "")
            rowBackground.backgroundColor = row.bgColor;
         return rowBackground;
      },
      // 自定义合计字段
      getSummaries({ columns, data }) {
         const sums = [];
         columns.forEach((column, index) => {
            if (index === 0) {
               sums[index] = '合计';
               return;
            }
            if (column.property == 'money') {
               let validValues = data
                  .map(item => {
                     let value = item[column.property];
                     // 处理各种可能的空值情况
                     if (value === null || value === undefined || value === '') {
                        return 0;
                     }
                     return isNaN(value) ? 0 : value;
                  })
                  .filter(num => !isNaN(num));
               if (validValues.length > 0) {
                  // 使用 reduce 计算总和，并处理浮点数精度问题
                  let sum = validValues.reduce((prev, curr) => {
                     return NP.plus(Number(prev), Number(curr));
                  }, 0);
                  // 格式化显示，使用系统统一的格式化方法
                  sums[index] = this.$common.getDecimalInfo(3, sum);
               } else {
                  sums[index] = '';
               }
            }
         });

         return [sums];
      },
      toDecimal(x) {
         var f = parseFloat(x);
         if (isNaN(f)) {
            return;
         }
         f = Math.round(x * 100) / 100;
         return f;
      },
      async onSubmit() {
         this.disabled = true
         const response = await this.$http[this.submitUrl]({
            list: this.returnData.list,
            state: 0
         })
         this.disabled = false
         if (response.status == 200) {
            this.$emit('closeExcel')
         } else {
            this.$message.error(response.message)
         }
      },
   },
};
</script>
<style scoped>
.imgupload {
   margin-left: 20px;
   padding-bottom: 20px;
}
</style>